<template>
    <div>
      <div>
        <div class="card-header">
          <div class="row">
            <div class="col-md-11">
              <h4>Informe de autorizaciones</h4>
              <p>
                El sistema le mostrará las
                <span class="text-success"
                  >Autorizaciones</span
                >
                activas a la fecha que no tengan la bolsa en 0
              </p>
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="row">
            <center>
              <div class="col-md-12" v-if="queriedData2 == ''">
                <center>
                  <img
                    src="/static/img/ICONOS/estadisticas.svg"
                    alt="Imagen de datos vacios"
                    width="70"
                  />
                  <p class="titulo-mensaje">Aún no hay datos para mostrar.</p>
                </center>
              </div>
            </center>
          </div>
          <!-- add this -->
          <div class="row" style="padding-left: 15px" v-if="queriedData2 != ''">
            <div class="col-3">
              <el-select
                class="select-default"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
          </div>
          <br />
          <div class="row" ref="component" v-if="queriedData2 != ''">
            <div class="col-md-12">
              <download-excel
                class="btn btn-secondary btn-fill mb-2"
                :data="json_data"
                :fields="json_fields"
                worksheet="Informe de autorizaciones"
                name="Informe de autorizaciones"
                v-if="json_data != ''"
              >
                Exportar a excel <i color="black" class="fa fa-download"></i>
              </download-excel>
              <br />
            </div>
            <div class="col-md-12">
              <br />
              <el-table border :data="queriedData" class="table-responsive table-striped mt-2">
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  style="height: 35px !important;"
                >
                  <template slot-scope="{ row }">
                    <div :class="getClass(column, row)" class="full-width">
                      <strong v-if="getClass(column, row) != ''">{{ row[column.prop] }}</strong>
                      <span v-else>{{ row[column.prop] }}</span>
                    </div>
                  </template>
                </el-table-column></el-table
              >
            </div>
          </div>
          <!-- add this -->
          <div class="row" v-if="queriedData2 != ''">
            <div class="col-sm-6 pagination-info">
              <br />
              <p class="category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <div class="col-sm-6">
              <p-pagination
                class="pull-right"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
              ></p-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
    
    <script>
  import axiosInstance from "src/global-services/axiosInstance";
  import Vue from "vue";
  import { Table, TableColumn, Select, Option } from "element-ui";
  import PPagination from "src/components/UIComponents/Pagination.vue";
  import JsonExcel from "vue-json-excel";
  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(Select);
  Vue.use(Option);
  Vue.component("downloadExcel", JsonExcel);
  
  export default {
    computed: {
      pagedData() {
        return this.queriedData2.slice(this.from, this.to);
      },
      queriedData() {
        if (!this.searchQuery) {
          this.pagination.total = this.queriedData2.length;
          return this.pagedData;
        }
        let result = this.queriedData2.filter((row) => {
          let isIncluded = false;
          for (let key of this.propsToSearch) {
            let rowValue = row[key].toString().toLowerCase();
            if (
              rowValue.includes &&
              rowValue.includes(this.searchQuery.toLowerCase())
            ) {
              isIncluded = true;
            }
          }
          return isIncluded;
        });
        this.pagination.total = result.length;
        return result.slice(this.from, this.to);
      },
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
      total() {
        this.pagination.total = this.queriedData2.length;
        return this.queriedData2.length;
      },
    },
    data: () => ({
      ip: "https://fundaintegra.com/",
      searchQuery: "",
      fechaInicial: "",
      fechaFinal: "",
      queriedData2: [],
      fechaActual: "",
      tableColumns: [
        {
          prop: "nombrePaciente",
          label: "Paciente",
          minWidth: 180,
        },
        {
          prop: "codigoOrden",
          label: "Codigo orden",
          minWidth: 150,
        },
        {
          prop: "fechaExpedicion",
          label: "F. expedición",
          minWidth: 90,
        },
        {
          prop: "fechaVencimiento",
          label: "F. vencimiento",
          minWidth: 90,
        },
        {
          prop: "total",
          label: "S. totales",
          minWidth: 50,
        },
        {
          prop: "bolsa",
          label: "S. bolsa",
          minWidth: 50,
        },
        {
          prop: "remaining",
          label: "% restante",
          minWidth: 70,
        }
      ],
      json_fields: {
        "Paciente": "nombrePaciente",
        "Codigo orden": "codigoOrden",
        "F. expedición": "fechaExpedicion",
        "F. vencimiento": "fechaVencimiento",
        "S. totales": "total",
        "S. bolsa": "bolsa",
        "% restante": "remaining"
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      SedesProgramacion: [],
      sede: "Sede Principal",
      rol: "",
      tipo: "",
      // add this
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0,
      },
    }),
    components: {
      PPagination,
    },
    methods: {
      async obtenerAutorizaciones() {
        try {
          this.$modal.show("carga");
          const sede = localStorage.getItem("sede");
          const response = await axiosInstance.get(
            `api/reportes/informe-autorizaciones/${sede}`
          );
          this.queriedData2 = response.data.data;
          this.json_data = response.data.data;
        } catch (error) {
          console.log("Error al obtener los datos:" + error);
        } finally {
          this.$modal.hide("carga");
        }
      },
      emailsProgramacion: function () {
        let config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        };
        const BASE_URL = `${this.ip}api/emailsProgramacion`;
        axios
          .get(BASE_URL, config)
          .then((res) => {
            let data = res.data.data;
            this.SedesProgramacion = data;
          })
          .catch((err) => {
            console.log(err);
          });
      },
      getClass(column, row) {
        if (column.prop === "remaining") {
          return row.classRemaining;
        }
        return "";
      },
    },
    mounted() {
      this.rol = localStorage.getItem("rol");
      if (localStorage.getItem("rol") != 1) {
        this.sede = localStorage.getItem("sede");
      }
      this.obtenerAutorizaciones();
      document.title = "Integra | Reporte de autorizaciones";
    },
  };
  </script>
    
  <style>
  .card {
    box-shadow: 0 0 0 0;
    border-radius: 15px;
    padding: 2%;
  }
  
  .btn {
    border-radius: 5px;
  }
  
  .high-percentage {
    background-color: #a0e2b3;
    /* color: white !important; */
  }
  
  .medium-percentage {
    background-color: #f2e3b0;
    /* color: black; */
  }
  
  .low-percentage {
    background-color: #fb817e;
    /* color: white; */
  }
  
  .full-width {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  
    /* padding: 15px; Si quieres mantener el padding interno */
  }
  
  .el-table__cell{
      height: 40px;
  }
  </style>
    


// WEBPACK FOOTER //
// src/components/Reportes/informeAutorizaciones.vue